import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

/* eslint-disable @typescript-eslint/indent, @typescript-eslint/brace-style */
export interface IOverlayFormTextAreaProps extends Omit<React.InputHTMLAttributes<HTMLTextAreaElement>,
                                                    'onChange' | 'className'>
{
    onChange: (value: string, original_event: React.ChangeEvent<HTMLTextAreaElement>) => any;
    error?: string;
    hideErrorMessage?: boolean;
    inputClassname?: string;
    wrapperClassname?: string;
}
/* eslint-enable @typescript-eslint/indent, @typescript-eslint/brace-style */


export const OverlayFormTextArea = React.forwardRef<HTMLTextAreaElement, IOverlayFormTextAreaProps>(
    ({
        inputClassname,
        wrapperClassname,
        placeholder,
        error = '',
        hideErrorMessage = false,
        required,
        onFocus,
        onBlur,
        onChange,
        ...restInputProps
    }, ref) => {
        const [ inputInFocus, setInputInFocus ] = React.useState<boolean>(false);
        const hasError = !!error;

        return (
            <div
                className={clsx(wrapperClassname, 'overlay-form-textarea-wrapper', {
                    'has-error': hasError
                })}
            >
                <textarea
                    ref={ref}
                    className={clsx(inputClassname, 'overlay-form-textarea')}
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                        if (onChange) {
                            let { value } = event.currentTarget;
                            onChange(value, event);
                        }
                    }}
                    onFocus={(...args) => {
                        setInputInFocus(true);
                        if (onFocus) {
                            onFocus(...args);
                        }
                    }}
                    onBlur={(...args) => {
                        setInputInFocus(false);
                        if (onBlur) {
                            onBlur(...args);
                        }
                    }}
                    {...restInputProps}
                />
                {(placeholder && !inputInFocus && !restInputProps.value) && (
                    <div className="fake-placeholder">
                        <span className='main-placeholder-text'>{placeholder}</span>
                        {required && (
                            <span className='required-marker'>*</span>
                        )}
                    </div>
                )}
                {hasError && !hideErrorMessage && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
            </div>
        );
    }
);
